<template>
  <div>
    <div class="back" v-if="visible" @click="closeDialog"></div>

    <div class="modalView" v-if="visible">
      <div class="modalView_pop">
        <div class="modalView_pop_l">
          <div class="modalView_pop_l_view">
            <div class="modalView_pop_l_view_t">
              <div class="modalView_pop_l_view_t_1">
                <img src="../../assets/images/server/img_1.png" alt="">
              </div>
              <div class="modalView_pop_l_view_t_2">—— 颠覆性的碳盘查服务</div>
            </div>
            <div class="modalView_pop_l_view_b">
              <div class="modalView_pop_l_view_b_3">
                <div class="modalView_pop_l_view_b_3_text1">在我们的碳盘查Agent中有四大颠覆性的创新:</div>
                <div class="modalView_pop_l_view_b_3_text2 mb3">1.方案自动规划和执行<br>无需人工介入，自动生成碳盘查全流程方案</div>
                <div class="modalView_pop_l_view_b_3_text2 mb3">2.跨源多模态数据自适应采集<br>自动识别和采集生产报表、设备日志、图像等多源数据</div>
                <div class="modalView_pop_l_view_b_3_text2 mb3">3.涵盖范围一二三的排放因子自适应匹配<br>自动匹配不同范围的排放因子，确保数据准确性</div>
                <div class="modalView_pop_l_view_b_3_text2">4.个性化排放报告<br>根据企业需求，生成标准化排放报告</div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CarbonInventoryDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {

    };
  },
  methods: {
    closeDialog() {
      this.$emit('close');
    }
  }
};
</script>

<style scoped lang="scss">
.back {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: rgba(33, 33, 33, 0.5);
  height: 100vh;
  z-index: 999;
}

.modalView {
  position: fixed;
  top: 10%;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(180deg, #7AE495 0%, #56C697 50%, #339E9E 100%);
  width: 900px;
  height: 623px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;

  .modalView_pop {
    width: calc(100% - 20px);
    height: calc(100% - 20px);
    background-color: #ffffff;
    /* 设置不透明的白色底色 */
    background-image: linear-gradient(180deg,
        rgba(222, 255, 231, 0.25) 0%,
        rgba(219, 255, 240, 0.25) 50%,
        rgba(219, 255, 255, 0.25) 100%);
    /* 渐变叠加在白色底色上 */
    border-radius: 20px;
    position: relative;
    display: flex;

    .modalView_pop_l {
      width: 900px;
      height: 100%;

      .modalView_pop_l_view {
        width: 800px;
        height: 100%;
        margin: 0 auto;
        border-left: 2px dashed rgba(58, 83, 36, 1);
        border-right: 2px dashed rgba(58, 83, 36, 1);

        .modalView_pop_l_view_t {
          width: 100%;
          border-bottom: 2px dashed rgba(58, 83, 36, 1);
          height: 130px;
          display: flex;
          flex-direction: column;
          justify-content: center;

          .modalView_pop_l_view_t_1 {
            width: 223px;
            height: 46px;
            margin-left: 33px;

            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }

            .modalView_pop_l_view_t_1_img {
              width: 159px;
              height: 42px;
            }

            .modalView_pop_l_view_t_3_img {
              width: 223px;
              height: 46px;
            }
          }

          .modalView_pop_l_view_t_2 {
            font-size: 18px;
            color: rgba(0, 0, 0, 1);
            font-weight: 500;
            margin-left: 35px;
            // margin-top: 10px;
          }
        }

        .modalView_pop_l_view_b {
          width: 100%;
          height: calc(100% - 130px);
          background: url(../../assets/images/server/server_back.png) no-repeat;
          background-size: 100% 80%;
          background-position: 0px 40px;
          position: relative;

          .modalView_pop_l_view_b_1 {
            position: absolute;
            top: 65px;
            left: 20px;

            .modalView_pop_l_view_b_1_text1 {
              font-size: 24px;
              font-weight: 600;
              color: rgba(58, 83, 36, 1);
            }

            .modalView_pop_l_view_b_1_text2 {
              font-size: 20px;
              font-weight: 500;
              color: rgba(0, 0, 0, 1);
              text-indent: 15px;
              margin-bottom: 25px;
            }
          }

          .modalView_pop_l_view_b_2 {
            margin: 29px 10px 30px 19px;
            height: auto;
            overflow-y: hidden;

            .modalView_pop_b_l_v_d_title {
              font-size: 24px;
              font-weight: 600;
              color: rgba(58, 83, 36, 1);
              letter-spacing: 2px;
            }

            .modalView_pop_b_l_v_d_buy {
              max-height: 410px;
              /* 设置最大高度，具体值根据需求调整 */
              overflow-y: auto;
              /* 启用垂直滚动条 */
              padding-right: 10px;
              /* 为滚动条预留空间，避免内容被遮挡 */
              scrollbar-width: thin;
              /* 优化滚动条宽度（Firefox） */
              scrollbar-color: rgba(117, 117, 117, 0.5) transparent;

              .modalView_pop_b_l_v_d_buy_title {
                font-size: 28px;
                color: rgba(117, 117, 117, 1);
                margin-top: 22px;
                margin-bottom: 30px;

                .modalView_pop_b_l_v_d_buy_title_sp {
                  color: rgba(0, 0, 0, 1);
                }
              }

              .mp89 {
                margin-top: 70px;
              }

              .mb40 {
                margin-bottom: 40px !important;
              }

              .mb {
                margin-bottom: 0px;
              }

              .modalView_pop_b_l_v_d_buy_choose {
                width: 592px;
                height: 87px;
                border: 1px solid rgba(117, 117, 117, 1);
                border-radius: 20px;
                display: flex;
                align-items: center;
                justify-content: space-around;
                cursor: pointer;
                margin-bottom: 15px;

                .modalView_pop_b_l_v_d_buy_choose_l {
                  display: flex;
                  flex-direction: column;
                  width: 440px;

                  .modalView_pop_b_l_v_d_buy_choose_l_1 {
                    font-size: 28px;
                  }

                  .modalView_pop_b_l_v_d_buy_choose_l_2 {
                    font-size: 14px;
                  }
                }

                .modalView_pop_b_l_v_d_buy_choose_r {
                  font-size: 16px;
                  color: rgba(0, 0, 0, 1);
                }
              }

              .activeF {
                border: 2px solid #339E9E;
              }

              .modalView_pop_b_l_v_d_buy_input {
                width: 592px;
                height: 87px;
                display: flex;
                align-items: center;
                margin-bottom: 50px;

                .modalView_pop_b_l_v_d_buy_choose_l {
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;
                  width: 440px;
                  font-size: 35px;
                  color: rgba(0, 0, 0, 1);

                  .modalView_pop_b_l_v_d_buy_input_view {
                    width: 107px;
                    height: 38px;
                    border: 1px solid rgba(117, 117, 117, 1);
                    border-radius: 5px;
                    margin-right: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 28px;
                    text-align: center;
                  }

                  .modalView_pop_b_l_v_d_buy_choose_l_text {
                    font-size: 28px;
                  }
                }

                .modalView_pop_b_l_v_d_buy_choose_r {
                  font-size: 16px;
                  color: rgba(0, 0, 0, 1);
                }
              }
            }
          }

          .modalView_pop_l_view_b_3 {
            position: absolute;
            top: 30px;
            left: 20px;

            .modalView_pop_l_view_b_3_text1 {
              font-size: 24px;
              font-weight: 600;
              color: rgba(58, 83, 36, 1);
            }

            .modalView_pop_l_view_b_3_text2 {
              font-size: 18px;
              // font-weight: 500;
              color: rgba(0, 0, 0, 1);
              margin-bottom: 25px;
            }

            .mb3 {
              margin-bottom: 45px;
            }
          }

          .modalView_pop_l_view_b_buyAndTest {
            margin: 26px 65px;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;

            .modalView_pop_l_view_b_buyAndTest_t {
              width: 310px;
              height: 420px;
              border: 1px solid rgba(215, 215, 215, 1);
              border-top-left-radius: 20px;
              border-bottom-left-radius: 20px;
              background: #fff;
              z-index: 0;

              .modalView_pop_l_view_b_buyAndTest_t_margin {
                margin: 8px 0px 13px 26px;

                .modalView_pop_l_view_b_buyAndTest_t_title {
                  font-size: 20px;
                  font-weight: 900;
                  color: rgba(0, 0, 0, 1);
                  letter-spacing: 5px;
                  margin-bottom: 15px;
                }

                .marginT {
                  margin-top: 25px;
                }

                .modalView_pop_l_view_b_buyAndTest_t_price {
                  font-size: 20px;
                  color: rgba(52, 159, 158, 1);
                  height: 48px;
                  line-height: 25px;
                  text-align: center;
                  font-family: Inter;
                  margin-top: 24px;

                  span {
                    font-weight: 700;
                    font-size: 32px;
                  }
                }

                .modalView_pop_l_view_b_buyAndTest_t_tiele_text {
                  font-size: 15px;
                  font-weight: 500;
                  color: rgba(0, 0, 0, 1);
                  margin: 24px auto 12px;
                }

                .modalView_pop_l_view_b_buyAndTest_t_text {
                  font-size: 15px;
                  font-weight: 500;
                  color: rgba(0, 0, 0, 1);
                  position: relative;
                  line-height: 22px;
                }

                .modalView_pop_l_view_b_buyAndTest_t_text::before {
                  content: "•";
                  /* 圆点字符 */
                  position: absolute;
                  left: -10px;
                  top: 50%;
                  transform: translateY(-50%);
                  color: #333;
                  /* 圆点颜色 */
                  font-size: 16px;
                  /* 圆点大小 */
                  line-height: 1;
                }

                .colorG {
                  color: rgba(52, 159, 158, 1);
                  line-height: 20px;
                  margin-top: 7px;
                  letter-spacing: 1px;
                }

                .modalView_pop_l_view_b_buyAndTest_t_btn {
                  width: 233px;
                  height: 40px;
                  border-radius: 20px;
                  color: rgba(33, 33, 33, 1);
                  font-size: 20px;
                  font-weight: 900;
                  display: flex;
                  background: linear-gradient(180deg, #DEFFE7 0%, #DBFFF0 50%, #DBFFFF 100%);
                  align-items: center;
                  justify-content: center;
                  cursor: pointer;
                  margin-top: 155px;
                }

                .modalView_pop_l_view_b_buyAndTest_b_btn {
                  width: 233px;
                  height: 40px;
                  border-radius: 20px;
                  color: #fff;
                  font-size: 20px;
                  font-weight: 900;
                  display: flex;
                  background: linear-gradient(180deg, #7AE495 0%, #56C697 50%, #339E9E 100%);
                  align-items: center;
                  justify-content: center;
                  cursor: pointer;
                  margin: 0px auto 0;
                }
              }
            }

            .modalView_pop_l_view_b_buyAndTest_b {
              width: 382px;
              height: 420px;
              z-index: 1;
              margin-left: -20px;
              border: 1px solid rgba(122, 228, 149, 1);
              border-radius: 20px;
              background: linear-gradient(180deg, #DEFFE7 0%, #DBFFF0 50%, #DBFFFF 100%);
              box-shadow: -4px 4px 8px 0px rgba(0, 0, 0, 0.25);
            }
          }
        }
      }
    }

    .modalView_pop_r {
      border-left: 2px solid rgba(58, 83, 36, 0.5);
      width: 344px;
      height: 100%;

      .modalView_pop_r_1 {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;

        .modalView_pop_r_1_t {
          width: 308px;
          height: 242px;
          background: linear-gradient(180deg, #7AE495 0%, #56C697 50%, #339E9E 100%);
          border-radius: 10px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-around;
          cursor: pointer;

          .modalView_pop_r_1_t_img {
            width: 278px;
            height: 156px;
          }

          .modalView_pop_r_1_t_v {
            width: 278px;
            height: 50px;
            background: linear-gradient(180deg, rgba(222, 255, 231, 0.5) 0%, rgba(219, 255, 240, 0.5) 50%, rgba(219, 255, 255, 0.5) 100%);
            border-radius: 30px;
            font-size: 20px;
            color: #fff;
            font-weight: 500;
            display: flex;
            align-items: center;
            justify-content: center;

            .modalView_pop_r_1_t_v_img {
              width: 25px;
              height: 25px;
              margin-left: 10px;
            }
          }
        }

        .modalView_pop_r_1_b {
          width: 170px;
          height: 64px;
          background: linear-gradient(180deg, #7AE495 0%, #56C697 50%, #339E9E 100%);
          border-radius: 10px;
          margin-top: 60px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          font-size: 24px;
          color: #fff;
          font-weight: 500;
        }

        .modalView_pop_r_1_position {
          position: absolute;
          right: 16px;
          bottom: 100px;
          width: 96px;
          height: 109px;
          z-index: 1;
        }

        .modalView_pop_r_1_position_img {
          position: absolute;
          right: 33px;
          bottom: 95px;
          width: 98px;
          height: 18px;
        }
      }

      .modalView_pop_r_2 {
        // width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        // align-items: center;
        justify-content: center;
        margin-left: 37px;
        margin-right: 37px;

        .modalView_pop_r_2_title {
          font-size: 24px;
          color: rgba(0, 0, 0, 1);
          font-weight: 700;
          margin-bottom: 30px;
        }

        .modalView_pop_b_r_v_1 {
          font-size: 20px;
          color: rgba(0, 0, 0, 1);
          margin-bottom: 5px;
          display: flex;
          justify-content: space-between;
        }

        .modalView_pop_b_r_v_2 {
          font-size: 20px;
          font-weight: 600;
          color: rgba(0, 0, 0, 1);
          margin-top: 140px;
        }

        .modalView_pop_b_r_v_3 {
          font-size: 20px;
          font-weight: 600;
          color: rgba(0, 0, 0, 1);
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 180px;

          .modalView_pop_b_r_v_3_t {
            font-family: Impact;
            font-size: 32px !important;
          }
        }

        .pay {
          width: 245px;
          height: 45px;
          background: linear-gradient(180deg, #E4E4E4 0%, #CACACA 50%, #9E9E9E 100%);
          border-radius: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 24px;
          cursor: pointer;

          .pay_inner {
            width: 240px;
            height: 40px;
            background: #F2F2F2;
            display: flex;
            border-radius: 20px;
            align-items: center;
            justify-content: center;
            font-size: 22px;
            color: rgba(117, 117, 117, 1);
          }
        }

        .activePay {
          background: linear-gradient(180deg, #7AE495 0%, #56C697 50%, #339E9E 100%);

          .pay_inner {
            background: transparent;
            color: #fff;
          }
        }
      }

      .modalView_pop_r_3 {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;

        .modalView_pop_r_3_1 {
          font-size: 24px;
          color: rgba(0, 0, 0, 1);
          font-weight: 600;
        }

        .modalView_pop_r_3_img {
          width: 190px;
          height: 190px;
          margin-top: 38px;
        }

        .modalView_pop_r_3_2 {
          font-size: 18px;
          color: rgba(0, 0, 0, 1);
          font-weight: 500;
          margin-top: 10px;
        }

        .modalView_pop_r_3_3 {
          font-size: 18px;
          color: rgba(0, 0, 0, 1);
          font-weight: 500;
          margin-top: 30px;
        }

        .modalView_pop_r_3_4 {
          font-size: 12px;
          color: rgba(0, 0, 0, 1);
          font-weight: 500;
        }
      }
    }
  }

  .modalView_pop_other {
    width: calc(100% - 20px);
    height: calc(100% - 20px);
    position: relative;

    .modalView_pop_other_video {
      width: 100%;
      height: 100%;
      object-fit: cover;
      position: relative;
      z-index: 1;
    }

    .modalView_pop_close {
      position: absolute;
      right: 30px;
      top: 30px;
      font-size: 28px;
      color: #fff;
      font-weight: 500;
      cursor: pointer;
      z-index: 2;
    }
  }
}

/* 如果使用scoped，可能需要调整选择器，例如使用深度选择器 >>> */
*[innerHTML*="<br>"] {
  display: inline-block;
  text-indent: 0;
}

*[innerHTML*="<br>"] br+* {
  display: block;
  text-indent: 2em;
}
</style>